export default {
  'contactCenterUser.idNumber': 'Id #',
  'contactCenterUser.contactPerson': 'Contact Person',
  'contactCenterUser.paymentDetails': 'Payment Details',
  'contactCenterUser.viewPayee': 'View Payee',
  'contactCenterUser.intermediaryBank1Code': 'Intermediary Bank 1 Code',
  'contactCenterUser.intermediaryBank2Code': 'Intermediary Bank 2 Code'
};
